<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item"><router-link to="/sale/quotes">{{ $t('sale_quote') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{title}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <b-btn variant="outline-primary no-bor" size="sm" @click="save"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="row-flex-x">
                                <div style="width: 100%">
                                    <div class="form-group">
                                        <label class="control-label blue">{{ $t('customer') }}</label>
                                        <div>
                                            <CustomerDropdown @select="customerSelected" :value="header.CustomerName" place="Choose a customer"></CustomerDropdown>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div class="form-group">
                                        <label class="control-label blue">&nbsp;</label>
                                        <button type="button" class="btn btn-outline-success btn-sm" style="width: 120px;">Add Customer</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('phone') }}</label>
                                <div>
                                    <input type="text" class="form-control form-control-sm" v-model="header.Phone" />
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div>                            
                            <DatePicker v-model="date" :label="$t('date')"/>
                        </div>
                        </div>
                    </div>
                    <div style="height: 50px;"></div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm no-bor">
                                <thead>
                                    <tr>
                                        <th style="width: 30px;"></th>
                                        <th>{{$t('product_or_service')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 100px;">{{$t('qty')}}</th>
                                        <!-- <th style="width: 120px;">{{$t('uom')}}</th> -->
                                        <th style="width: 100px;">{{$t('unit_price')}}</th>
                                        <th class="text-right" style="width: 100px;">{{$t('amount')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret,index) in lines" :key="ret.Id">
                                        <td style="width: 30px;">
                                            <button type="button" class="btn btn-danger btn-remove" @click="onRemove(index)">X</button>
                                        </td>
                                        <td><AuthCompleted @select="itemSelect($event, ret)" :value="ret.ItemName"></AuthCompleted></td>
                                        <td class="text-center">
                                            <input type="text" class="form-control form-control-sm" v-model="ret.Description" :disabled="ret.ItemId==''">
                                        </td>
                                        <td class="text-center">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Quantity" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <!-- <td>
                                            <UomDropdown :value="ret.UomName" :item_id="ret.ItemId" @select="uomChange($event, ret)"></UomDropdown>
                                        </td> -->
                                        <td class="text-right">
                                            <input type="number" class="form-control form-control-sm" v-model="ret.Price" @keypress="$isKeyNumber" @change="reCalculate" :disabled="ret.ItemId==''">
                                        </td>
                                        <td class="text-right">
                                            <input type="text" class="form-control form-control-sm text-right" :value="$money(ret.SubTotal)" readonly />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div style="display: flex; gap: 8px; padding: 15px 0;">
                                <button type="button" class="btn btn-outline-primary btn-sm" @click="addLine"><i class="fa fa-plus"></i> {{ $t('add_line') }}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" @click="onClearLine"><i class="fa fa-times"></i> {{ $t('clear_all_line') }}</button>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="row-flex-x" style="justify-content: flex-end; padding: 15px 0; font-weight: 600;">
                                <div>
                                    {{$t('total')}}:
                                </div>
                                <div style="min-width: 100px;text-align: right;">
                                    {{$money(header.PaidAmount)}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="form-group">
                                <label class="control-label blue">{{ $t('memo') }}</label>
                                <div>
                                    <textarea class="form-control form-control-sm" v-model="header.Remark"></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { AuthCompleted } from '../Item';
import { CustomerDropdown } from '../Customer';
import UomDropdown from '../UOM/Dropdown';
import DatePicker from "../Components/DatePicker.vue";     
export default {
    components: {
        AuthCompleted,
        CustomerDropdown,
        UomDropdown,
        DatePicker
    },
    data: function(){
        return {
            title: this.$t('sale_quote_create'),
            header: {
                CustomerId: '',
                CustomerName: '',
                Phone: '',
                GrandTotal: 0,
                TaxVat: 0,
                PaidAmount: 0
            },
            lines: [{
                ItemId: '',
                ItemName: '',
                UomId: '',
                UomName: '',
                Quantity: 1,
                Price: 1,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 1
            }],
            date: this.$now().format('YYYY-MM-DD'),
        }
    },
    created(){
        let id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            let loading = this.$loading.show();
            this.$api().post('quote/find', { Id: id, CompanyId: this.$store.state.company.Id }).then(res => {
                if(this.$isValid(res)){
                    let data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.date = this.header.Date;
                    this.title = this.$t('sale_quote_update') +' ['+ this.header.Num + ']';
                }
            }).finally(function(){ loading.hide(); });
        }
    },
    methods: {
        addLine(){
            this.lines.push({
                ItemId: '',
                ItemName: '',
                UomId: '',
                UomName: '',
                Quantity: 1,
                Price: 1,
                Discount: 0,
                TaxLine: 0,
                SubTotal: 1
            });
        },
        save(){
            if(this.lines.length > 0){
                let loading = this.$loading.show();                
                this.header.Date = this.date;
                this.header.CompanyId = this.$store.state.company.Id;
                this.header.ClientId = this.$store.state.company.ClientId;
                var req = {
                    Header: this.header,
                    Lines: this.lines
                };
                this.$api().post('quote/save', req).then(res => {
                    if(this.$isValid(res)){
                        this.$router.push('/sale/quotes');
                    }
                }).finally(function() { loading.hide();});
            }
        },
        customerSelected(evt){
            this.header.CustomerId = evt.data.Id;
            this.header.CustomerName = evt.data.Name;
            this.header.Phone = evt.data.Phone;
        },
        reCalculate(){
            let subTotal = 0;
            let total = 0;
            this.lines.map(item => {
                subTotal = item.Quantity * item.Price;
                item.SubTotal = subTotal;
                total += subTotal;
            });
            this.header.PaidAmount = total;
        },
        itemSelect(evt, line){
            console.log(evt);
            line.ItemId = evt.data.Id;
            line.ItemName = evt.data.Name;            
            line.Price = evt.Price;
            this.reCalculate();
        },
        onRemove(index){
            this.lines.splice(index, 1);
            this.reCalculate();
        },
        uomChange(e, line){
            line.UomId = e.UomId;
            line.UomName = e.UomName;
            line.Price = e.Price;
            this.reCalculate();
        },
        onClearLine(){
            this.lines  = [];
            this.reCalculate();
        }
    }
}
</script>